/**
 * Extracts the number from a CSS value
 */
export function unit2number(value: string, regex = /px|rem|rm|%/) {
  return Number.parseInt(value.replace(regex, ''), 10);
}
